import React from "react";
import "./Common_Title.css";

const Common_Title = ({ pageTitle, boxText }) => {
    return (
        <div className="Common_Title">
            {pageTitle && <p className="page_title underline">{pageTitle}</p>}
            {boxText && <p className="box_text">{boxText}</p>}
        </div>
    );
};

export default Common_Title;
